import Categories from '@dehaat/kisan-app-bl/models/CategoriesV2'

import { get } from '../axios/serverConfig'
export interface RequestParmas {
  crop_ids: string
  brand_ids: string
  lang: string
  vendor_id: string
  isprebook: boolean
}

const fetchAllCategoriesV2 = async (params: Partial<RequestParmas>) => { 
  try {
    return await get<Categories[]>(`/hyperlocal/v1/all-categories`, params)
  } catch {
    return null
  }
}

export default fetchAllCategoriesV2
